<template>
  <v-menu
    v-model="date_sync"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateComp"
        :label="name"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        clearable
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dateComp"
      first-day-of-week="1"
      @input="date_sync = false"
    />
  </v-menu>
</template>
<script>
import moment from 'moment';

export default {
  name: "DatePickerCustom",
  props: {
    value: { required: false, type: String, default: null },
    name: { required: true, type: String }
  },

  data() {
    return {
      date_sync: false,
      date: this.value
    };
  },

  computed: {
    dateComp: {
      get: function () {
        return this.date;
      },

      set: function (newValue) {
        this.date = newValue;
        this.$emit("input", newValue);
      }
    },

    dateText: {
      get: function () {
        try {
          return moment(this.date).format('DD.MM.YYYY');
        } catch (e) {
          return "";
        }
      },

      set: function (newValue) {
        try {
          this.date = moment(newValue).format('YYYY-MM-DD');
          // this.$emit("input", moment(newValue).format('YYYY-MM-DD'));

        } catch (e) {
          this.date = "";
        }
      }
    },

    datePicker: {
      get: function () {
        try {
          return moment(this.date).format('YYYY-MM-DD');
        } catch (e) {
          return "";
        }
      },

      set: function (newValue) {
        // console.log("picker " + newValue);
        this.date = newValue;
        // this.$emit("input", moment(newValue).format('YYYY-MM-DD'));
      }
    }
  },
};
</script>